
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import TipoDocumentoFinanceiroModal from './TipoDocumentoFinanceiroModal.vue';
import ServicoTipoDocumentoFinanceiro from '@/servicos/Cadastros/Financeiro/ServicoTipoDocumentoFinanceiro';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';

export default defineComponent({
  name: 'TipoDocumentoFinanceiro',
  components: {
    TelaPadraoCrud,
    TipoDocumentoFinanceiroModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoTipoDocumentoFinanceiro = new ServicoTipoDocumentoFinanceiro();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da tipo de documento';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Meio de Pagamento', dataIndex: 'descricaoMeioPagamento', key: 'MeioPagamento', position: 2, visible: true, ordering: true, width: 300,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 3, visible: true, ordering: true, customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Sigla', dataIndex: 'sigla', key: 'Sigla', position: 4, visible: true, ordering: true, width: 70,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 5, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 80,
      },
      {
        title: 'Ações', key: 'acoes', position: 6, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoTipoDocumentoFinanceiro,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      refCrud,
    };
  },
});
